<template>
<otif-table
    ref="table"
    :title="title"
    :rows="resources"
    :columns="columns"
    :globalActions="globalActions"
    :paginated="true"
    :sortCallback="sort"
    :pageSizeCallback="setPageSize"
    :selectPageCallback="selectPage"
    :totalRowsCallback="totalRows"
    :currentPageCallback="currentPage"
    :filters="filters"
    @pageSize="setPageSize"
    @filter="setFilters"
    :server="true"
    :actions="actions">
    <slot name="table-header" slot="table-header"/>
    <slot name="empty" slot="empty">
        No items available.
    </slot>
</otif-table>
</template>

<script>

export default {
    props: ['collection', 'actions', 'globalActions', 'columns', 'title', 'filters'],

    computed: {
        resources: {
            cache: false,
            get() {
                return this.collection.resources;
            }
        }
    },

    methods: {
        setFilters(filters) {

            Object.keys(filters).forEach((filter) => {
                this.collection.setFilter(filter, filters[filter]);
            });

            this.collection.fetch();
        },
        sort(colNumber, dir) {
            const fieldName = this.columns[colNumber].name;
            this.collection.sort(fieldName, dir);
        },

        setPageSize(pageSize) {
            this.collection.setPageSize(pageSize);
            this.collection.selectPage(0);
        },

        selectPage(page) {
            this.$refs['table'].currentPage = page;
            this.collection.selectPage(page);
        },

        currentPage() {
            return this.collection.current_page;
        },

        totalRows() {
            return this.collection.total_count;
        }
    }
}

</script>
